<template>
  <div class="login-container flex flex-column flex-between">
    <div class="login-form">
      <div class="logo-wrapper text-center">
        <img class="logo" :src="logo" alt="logo" />
      </div>
      <div v-if="type === 'login'">
        <div class="flex flex-center regist">
          <div
            class="flex flex-center item-center flex-1 pointer"
            :class="act === v.value ? 'act' : ''"
            v-for="(v, i) in tabList"
            :key="i"
            @click="tabstwich(v)"
          >
            {{ v.name }}
          </div>
        </div>
        <div v-if="act === 1" style="margintop: 40px">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            @submit.native.prevent
            auto-complete="on"
            label-position="top"
          >
            <el-form-item prop="username">
              <el-input
                v-model.trim="loginForm.username"
                type="text"
                size="small"
                clearable
                auto-complete="on"
                placeholder="用户名"
              />
            </el-form-item>
            <el-form-item prop="password">
              <!-- <div class="svg-container">
          <span class="hmicon icon-mima" />
              </div>-->
              <el-input
                :type="pwdType"
                v-model.trim="loginForm.password"
                auto-complete="on"
                size="small"
                clearable
                placeholder="密码"
                @keyup.enter.native="handleLogin"
              />
              <div class="show-pwd" @click="showPwd">
                <span class="hmicon icon-yanjing" />
              </div>
            </el-form-item>
            <el-form-item class="no-border">
              <el-button
                :loading="loading"
                type="primary"
                style="width: 100%"
                @click.native.prevent="handleLogin"
                >绑定账号</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div v-else-if="act === 2" style="margintop: 40px">
          <el-form
            ref="loginForms"
            :model="loginForms"
            :rules="loginMobile"
            auto-complete="on"
            label-position="left"
          >
            <el-form-item prop="mobile">
              <!-- <span class="svg-container">
          <span class="hmicon icon-xingmingyonghumingnicheng" />
                </span>-->
              <el-input
                v-model.trim="loginForms.mobile"
                type="number"
                size="small"
                clearable
                auto-complete="on"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="authCode" class="flex auth-wrapper">
              <div class="flex item-center" style="height: 100%">
                <el-input
                  v-model.trim="loginForms.authCode"
                  size="small"
                  clearable
                  placeholder="请输入验证码"
                  class="mr20"
                />
                <el-button
                  :loading="loading"
                  type="primary"
                  style="small"
                  v-if="show"
                  @click.native.prevent="getCode"
                  >获取短信验证码</el-button
                >
                <el-button type="primary" style="small" v-else>{{
                  time + "秒后获取"
                }}</el-button>
              </div>
            </el-form-item>
            <el-form-item class="no-border">
              <el-button
                :loading="loading"
                type="primary"
                style="width: 100%"
                :disabled="isClick"
                @click.native.prevent="codeLogin('loginForms')"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div v-else-if="act === 3" style="margintop: 40px">
          <div id="login_code" class="flex flex-center"></div>
        </div>
      </div>
      <!-- <p
        @click="type = 'register'"
        v-if="type === 'login'"
        style="
          height: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(229, 0, 101, 1);
          cursor: pointer;
        "
      >
        立即注册
      </p> -->
      <div v-if="type === 'register'">
        <div class="flex flex-center item-center regist">免费注册</div>

        <div style="margintop: 50px" v-if="types === 'regSucceed'">
          <div class="flex flex-center mb10" style="flex: 1; height: 50px">
            <span
              class="hmicon icon-zhengpinbaozhangduigou flex flex-center item-center"
              style="fontsize: 54px; color: #2fc348"
            ></span>
          </div>

          <p
            class="flex flex-center mb10"
            style="color: #222222; fontsize: 16px; fontweight: 700"
          >
            已提交成功，等待审核
          </p>
          <p
            class="flex flex-center"
            style="color: #aaaaaa; fontsize: 14px; fontweight: 700"
          >
            您可以添加禾苗客服微信确认账号申请进度
          </p>
          <div
            class="flex flex-center"
            style="flex: 1; height: 150px; margintop: 35px"
          >
            <img
              class="flex flex-center"
              src="https://imgcdn.hemiao100.com/hemiaoBase/f84fbbd1-1cab-47de-8c9f-14569e8dc9db.png"
              alt
              style="width: 150px"
            />
          </div>
        </div>

        <el-form
          v-else
          style="margintop: 40px"
          ref="registerForm"
          :model="registerForm"
          :rules="registerRules"
          label-position="left"
          @submit.native.prevent
        >
          <el-form-item prop="companyName">
            <el-input
              v-model.trim="registerForm.companyName"
              size="small"
              clearable
              auto-complete="on"
              placeholder="请输入公司名称"
            />
          </el-form-item>
          <el-form-item prop="customersName">
            <el-input
              v-model.trim="registerForm.customersName"
              size="small"
              clearable
              auto-complete="on"
              placeholder="请输入用户名"
            />
          </el-form-item>
          <el-form-item prop="customersMobile">
            <el-input
              v-model.trim="registerForm.customersMobile"
              type="number"
              size="small"
              clearable
              auto-complete="on"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item prop="verifyCode" class="duanxin">
            <div class="flex item-center" style="height: 100%">
              <el-input
                v-model.trim="registerForm.verifyCode"
                size="small"
                clearable
                placeholder="请输入验证码"
                style="width: 210px"
              />
              <el-button
                class="verifications"
                :loading="loading"
                type="primary"
                style="small"
                v-if="showRegister"
                @click.native.prevent="getRegisterCode"
                >获取短信验证码</el-button
              >
              <el-button
                class="verifications"
                type="primary"
                style="small"
                v-else
                >{{ timeRegister + "秒后获取" }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item class="no-border">
            <el-button
              :loading="loading"
              type="primary"
              style="width: 100%"
              :disabled="isRegisterClick"
              @click.native.prevent="codeRegister"
              >提交注册信息</el-button
            >
          </el-form-item>
          <span style="color: rgba(170, 170, 170, 1); font-size: 14px"
            >已有账号</span
          >
          <span
            style="color: #e50065; font-size: 14px; cursor: pointer"
            @click="type = 'login'"
            >去登录</span
          >
        </el-form>
      </div>
    </div>
    <div class="copyright">
      <div class="qrcode flex flex-column flex-center item-center">
        <img
          src="https://imgcdn.hemiao100.com/hemiaoBase/lALPD2eDO-KFKNDNAYzNAYw_396_396.png_720x720q90g.jpg"
          alt="微信扫码"
        />
        <p class="text">微信扫码联系我们</p>
      </div>
      <a target="_blank" class="link" href="http://www.hemiao100.com">
        Copyright©{{ thisYear }}禾苗(武汉)信息技术有限公司.ALL rights reserved.
      </a>
      <a
        target="_blank"
        style="margin-left: 10px"
        href="https://beian.miit.gov.cn"
        >鄂ICP备15014881号</a
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { encryption } from "@/utils/encryption/aesEncrypt";
import { setToken, setLoginUser } from "@/utils/auth";
import { removeCookie, getCookie } from "@/utils/utils";

export default {
  name: "Wxlogin",
  data() {
    const validateUsername = (rule, value, callback) => {
      // if (!isvalidUsername(value)) {
      //   callback(new Error("请输入正确的用户名"));
      // } else {
      //   callback();
      // }
      if (value.length < 3) {
        callback(new Error("用户名不能小于3位"));
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    return {
      tabList: [
        {
          name: "绑定账号登录",
          value: 1
        }
        // {
        //   name: "短信登录",
        //   value: 2
        // },
        // {
        //   name: "扫码登入",
        //   value: 3
        // }
      ],
      logo: "https://imgcdn.hemiao100.com/hemiaoBase/login_logo.png",
      thisYear: new Date().getFullYear(),
      loginForm: {
        username: "",
        password: ""
      },
      loginForms: {
        mobile: "",
        authCode: ""
      },
      registerForm: {},
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
      },
      loginMobile: {
        mobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        }
      },
      registerRules: {
        companyName: {
          required: true,
          message: "请输入公司名称",
          trigger: "blur"
        },
        customersName: {
          required: true,
          message: "请输入用户名",
          trigger: "blur"
        },
        customersMobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        }
      },
      loading: false,
      pwdType: "password",
      redirect: undefined,
      show: true,
      showRegister: true,
      time: 59,
      timeRegister: 59,
      type: "login",
      types: "",
      act: 1,
      potentialCustomersId: "",
      state: "",
      wxLoginUuidInfo: {}
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
        if (route.query.info && route.query.redirect) {
          const info = JSON.parse(
            decodeURIComponent(window.atob(route.query.info))
          );
          const { username, password, timeStamp } = info;
          const time = moment(moment(timeStamp).format("YYYY-MM-DD HH:mm:ss"));
          const nowBefore = moment()
            .subtract(10, "minutes")
            .format("YYYY-MM-DD HH:mm:ss");
          const nowAfter = moment()
            .add(10, "minutes")
            .format("YYYY-MM-DD HH:mm:ss");
          if (time.isBetween(nowBefore, nowAfter)) {
            this.loginForm.username = username;
            this.loginForm.password = password;
            this.sendLoginRequest();
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    //手机号和验证码都不能为空
    isClick() {
      if (!this.loginForms.mobile || !this.loginForms.authCode) {
        return true;
      } else {
        return false;
      }
    },
    isRegisterClick() {
      if (!this.registerForm.customersMobile || !this.registerForm.verifyCode) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.queryLoginCustomLogoDateRange();
  },
  mounted() {
    this.wxLoginUuidInfo = JSON.parse(
      getCookie({
        key: "UUID_INFO",
        type: "session"
      })
    );
    console.log("this.wxLoginUuidInfo: ", this.wxLoginUuidInfo);
    // if (!this.$store.state.system.wxLoginUuidInfo.wxLoginUuid) {
    //   this.$router.push({
    //     name: "login"
    //   });
    //   return;
    // }
  },
  methods: {
    tabstwich(v) {
      this.act = v.value;
    },
    async queryLoginCustomLogoDateRange() {
      const { result } = await this.$store.dispatch(
        "queryLoginCustomLogoDateRange"
      );
      if (result && result.length) {
        const startDate = moment(result[0].itemValue.split("#")[0]).subtract(
          1,
          "days"
        );
        const endDate = moment(result[0].itemValue.split("#")[1]).add(
          1,
          "days"
        );
        const isBetween = moment(moment().format("YYYY-MM-DD")).isBetween(
          startDate,
          endDate
        );
        if (isBetween) {
          this.logo = "https://imgcdn.hemiao100.com/hemiaoBase/customLogo.png";
        }
      }
    },
    codeRegister() {
      this.registerForm.potentialCustomersId = this.potentialCustomersId;
      this.$store.dispatch("codeRegister", this.registerForm).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "注册成功",
            type: "success"
          });
          this.types = "regSucceed";
        }
      });
    },
    async codeLogin(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const { result } = await this.$store.dispatch(
          "codeLogin",
          this.loginForms
        );
        const { token, userInfo } = result;
        setToken(token);
        let data = {
          realname: userInfo.realname,
          storeId: "",
          storeCode: userInfo.storeCode,
          roles: ["editor"],
          userId: "",
          phone: userInfo.phone
        };
        setLoginUser(data);

        this.$store.commit("SET_TOKEN", token);
        // 获取是否跳转到新平台
        const domainInfo = await this.$store.dispatch("getHref");
        const hostname = window.location.hostname.split(".")[0];
        const { visitDomain } = domainInfo;
        if (
          hostname.indexOf("hexin") === -1 &&
          hostname !== "localhost" &&
          hostname !== visitDomain
        ) {
          window.location.href = `//${visitDomain}.hemiao100.com?token=${token}&username=${userInfo.username}`;
          // this.dispatch('LogOut')
          removeCookie({ key: "token" });
          removeCookie({ key: "token", type: "local" });
          return;
        }
        let path = "/";
        if (this.redirect) {
          path = this.redirect;
        }
        this.$router.push({
          path,
          query: {
            from: "login"
          }
        });
      } else {
        return false;
      }
    },
    getRegisterCode() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          this.registerForm.requestIp = window.location.hostname;
          this.$store
            .dispatch("getRegisterCode", this.registerForm)
            .then(res => {
              //倒计时
              if (res.code == 0) {
                this.$message({
                  message: "发送成功",
                  type: "success"
                });
                this.potentialCustomersId = res.result.potentialCustomersId;
                this.timeRegister = 59;
                this.showRegister = false;
                const timer = setInterval(() => {
                  if (this.timeRegister < 1) {
                    clearInterval(timer);
                    // this.isSending = false;
                    this.showRegister = true;
                  } else {
                    this.timeRegister = this.timeRegister - 1;
                  }
                }, 1000);
              }
            });
        } else {
          return false;
        }
      });
    },
    getCode() {
      this.$refs.loginForms.validate(valid => {
        if (valid) {
          this.loginForms.requestIp = window.location.hostname;
          this.$store.dispatch("getcode", this.loginForms).then(res => {
            //倒计时
            if (res.code == 0) {
              this.$message({
                message: "发送成功",
                type: "success"
              });
              this.time = 59;
              this.show = false;
              const timer = setInterval(() => {
                if (this.time < 1) {
                  clearInterval(timer);
                  // this.isSending = false;
                  this.show = true;
                } else {
                  this.time = this.time - 1;
                }
              }, 1000);
            }
          });
        } else {
          return false;
        }
      });
    },
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.sendLoginRequest();
        } else {
          return false;
        }
      });
    },
    async sendLoginRequest() {
      try {
        const { result } = await this.$store.dispatch("getEncryptedString");
        const { key, iv } = result;
        const params = JSON.parse(JSON.stringify(this.loginForm));
        params.password = encryption(params.password, key, iv);

        Object.assign(params, this.wxLoginUuidInfo);
        console.log("params: ", params);
        this.$store
          .dispatch("WxLogin", params)
          .then(res => {
            console.log("res: ", res);
            this.loading = false;
            let path = "/";
            setTimeout(() => {
              if (sessionStorage.getItem("USER_MENU") === "0") {
                const h = this.$createElement;
                this.$notify({
                  title: "提示",
                  message: h(
                    "span",
                    { style: "color: teal" },
                    "该角色账户无权限!"
                  ),
                  type: "warning"
                });
              }
            }, 1000);
            if (this.redirect) {
              path = this.redirect;
            }
            console.log("path: ", path);
            this.$router
              .push({
                path,
                query: {
                  from: "login"
                }
              })
              .catch(() => {});
          })
          .reject(() => {
            this.loading = false;
          });
      } catch (err) {
        this.loading = false;
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
$bg: #fff;
$light_gray: #666;

/* reset element-ui css */
.login-container {
  height: 100vh;
  overflow-y: auto;
  .el-form-item__content {
    border: 1px solid #e3e3e3;
    background: #fff;
    border-radius: 3px;
    height: 48px;
    width: 100%;
  }
  .no-border {
    .el-form-item__content {
      border: none;
    }
  }
  .el-input {
    display: inline-block;
    height: 40px;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: #666 !important;
      }
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #fff;
$dark_gray: #889aa4;
$light_gray: #eee;
.login-container {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: $bg;
  background-size: cover;
  background-position: 50% 100%;
  .copyright {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 30px;
    text-align: center;
    color: rgba(34, 34, 34, 0.8);
    font-size: 12px;
    .mobile {
      margin-bottom: 12px;
    }
  }
  .login-form {
    padding-top: 20px;
    width: 360px;
    margin: 0 auto;
    background: #fff;
    position: relative;
    z-index: 1;
  }
  .act {
    position: relative;
    border-bottom: 1px solid #e50065;
    &::after {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      content: "";
      border: 8px solid transparent;
      border-bottom-color: #e50065;
    }
  }
  .regist {
    height: 100px;
    font-size: 24px;
    margin-bottom: 40px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .title {
    font-size: 26px;
    color: #333;
    margin: 0px auto 40px auto;
    text-align: center;
    letter-spacing: 5px;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}

.system-name {
  margin: 0 40px 50px 40px;
  font-size: 16px;
}

.iamge-wrapper {
  width: 44px;
  margin-right: 8px;
}

@media screen and (max-width: 375px) {
  .login-container {
    .login-form {
      width: 300px;
      padding-top: 20px;
    }
  }
}

.qrcode {
  position: absolute;
  right: 20px;
  bottom: 100px;
  width: 106px;
  img {
    width: 100%;
  }
  .text {
    margin-top: 10px;
  }
}
</style>
